/**
 * @generated SignedSource<<984c7476fa69883b75f9aed056d24a14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HeaderSubIssueSummaryWithPrimary$data = {
  readonly subIssuesSummary: {
    readonly completed: number;
    readonly total: number;
  };
  readonly " $fragmentType": "HeaderSubIssueSummaryWithPrimary";
};
export type HeaderSubIssueSummaryWithPrimary$key = {
  readonly " $data"?: HeaderSubIssueSummaryWithPrimary$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderSubIssueSummaryWithPrimary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderSubIssueSummaryWithPrimary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SubIssuesSummary",
      "kind": "LinkedField",
      "name": "subIssuesSummary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completed",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "2c97bd914c3536caa3a935909c50f6df";

export default node;
